import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Form, Input} from "rsuite";
import PhoneInput from "../Form/PhoneInput/PhoneInput";
import {useAppSelector} from "../../hooks";
import SubscriptionModel from "../../interfaces/SubscriptionModel";
import subscriptionservices from "../../services/subscriptionservices";
import {SubscriptionType} from "../../enums/SubscriptionType";
import {useParams} from "react-router-dom";


function TextField(props: any) {
    const { fieldName, value, setValue, accepter, label, ...rest } = props;
    return (
        <Form.Group controlId={`${fieldName}-3`} key={`${fieldName}-3`}>
            <Form.Control
                name={fieldName}
                value={value}
                onChange={setValue}
                key={`${fieldName}-4`}
                accepter={accepter} {...rest}
            />
        </Form.Group>
    );
}

const FormSubscribeModalPL: React.FC<{
    handleCloseSubscription: Function,
    setIsSubscribed: Function,
    disableNewProducts: boolean
}> = ({handleCloseSubscription, setIsSubscribed, disableNewProducts}) => {
    const { t } = useTranslation();
    let {categoryId} = useParams();

    let {productId} = useParams();

    const filterInfo = useAppSelector(state => state.filters.value)
    const chosenFilters = useAppSelector(state => state.chosenFilters.value)
    const location = process.env.REACT_APP_LOCATION;

    const [errorVisible, setErrorVisible] = useState(false);

    const [email, setEmail] = useState('')

    const [sType, setSType] = useState<SubscriptionType>(0)
    const changeType = (type: number) => {
        setSType(sType ^ type)
    }

    const subscribe = () => {

        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = re.test(email);
        setErrorVisible(isEmailValid);

        const data: SubscriptionModel = {
            type: sType,
            email: email,
            filters: {
                "fromPrice": filterInfo.priceFrom,
                "toPrice": filterInfo.priceTo,
                "sortOrder": 0,
                "id": productId ? +productId : null,
                "categoryId": categoryId ? +categoryId : null,
                "propertyFilters": chosenFilters,
                "customFilters": null,
                "page": 0,
                "itemsPerPage": 0,
            }
        }
        if((location == 'ua' && !errorVisible )){
            setErrorVisible(true)
        } else {
            setErrorVisible(false)
            subscriptionservices.addSubscription(data).then(data => {
                setIsSubscribed(false)
            })
        }


    }

    return (
        <div className="form-subscribe-modal-wrapper">
            <Form fluid>
                <div className="input-wrapper">
                    <Form.Group>
                        <div className="email">
                            <TextField
                                name="email"
                                placeholder={t('form.email')}
                                key={'email'}
                                value={email}
                                setValue={setEmail}
                                label={t('form.email')}
                            />
                        </div>
                    </Form.Group>
                </div>
                <div>
                    <label>
                        <input type={"checkbox"} disabled={disableNewProducts} onClick={() => changeType(SubscriptionType.NewProducts)} />{' '}
                        <span className={"checkbox"}>{t('isSubscribed.newProducts')}</span>
                    </label>
                </div>
                <div>
                    <label>
                        <input type={"checkbox"}  onClick={() => changeType(SubscriptionType.Availability)} />{' '}
                        <span className={"checkbox"}>{t('isSubscribed.presentsProducts')}</span>
                    </label>
                </div>
                <button type="submit" className="btn btn-lg" onClick={subscribe} >{t('subscribe')}</button>
            </Form>
        </div>
    )
}
export default FormSubscribeModalPL